import clsx from 'clsx'

import s from './Input.module.scss'
import type { InputProps } from './Input.props'

export function Input({ className, icon, error, ...props }: InputProps) {
  return (
    <label className={clsx(s.wrapper, className)}>
      {!!icon && (
        <img
          src={icon}
          alt="Icon"
          className={s.icon}
          width={24}
          height={24}
        />
      )}
      <input
        type="text"
        className={clsx(s.input, { [s.withIcon]: !!icon })}
        {...props}
      />
      {!!error && (
        <span className={s.error}>{error}</span>
      )}
    </label>
  )
}
